<template>
  <g-master :name="master.endpoint"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :parentData="parentData"
            :actions="false"
  >
  </g-master>
</template>
<script>
  export default {
    props: ['empleadoseleccionado'],
    data () {
      return {
        master: {
          endpoint: 'absen',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'abs_id'
            },
            columns: [
              {title: 'Inicio', dataIndex: 'abs_inicial', sorter: true},
              {title: 'Fin', dataIndex: 'abs_final', sorter: true},
              {title: 'Dias', dataIndex: 'abs_days', sorter: true}
            ]
          }
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/Ausentismo.vue